import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"row"} }

import LocationForm from '@/components/locations/LocationForm.vue';
import { Mutations, ShiftCMSState } from '@/store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';
import { LocationsActions, LocationsState } from '@/stores/locations.store';
import { Location } from '@/models/location.model';
import { useEvents, Event } from '@/services/events.composable';
import TranslatedState from '../common/TranslatedState.vue';
import ListFilter from '../common/ListFilter.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LocationsList',
  setup(__props) {

const store = useStore<ShiftCMSState & { los: LocationsState }>();
const items = computed<Location[]>(() => store.state.los.items);
const events = useEvents();

const update = () => {
  store.dispatch(LocationsActions.GetLocations);
};

onMounted(() => {
  update();
  events.on(Event.LanguageChanged, update);
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
  events.off(Event.LanguageChanged, update);
});

const editLocation = (_: Event, { item }: { item: Location }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(LocationForm),
    data: item,
  });
};

const addLocation = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(LocationForm) });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Name', key: 'name', width: '20%' },
  { title: 'Type', key: 'type', width: '15%' },
  { title: 'Radius', key: 'radius', width: '5%' },
  { title: 'Parent', key: 'parentLocation.name', width: '15%' },
];

const filter = ref<string>('');
const filterTitle = ref<string>('');
const filteredItems = computed<Location[]>(() => {
  return items.value.filter((v: Location) => {
    if (filterTitle.value) {
      return [v.name]
        .map((s) => s.toLowerCase())
        .join('')
        .includes(filterTitle.value);
    }

    return true;
  });
});

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filter.value = filters.filter;
  filterTitle.value = filters.filterTitle;

  console.log(filters.filter, filters.filterTitle);
}

return (_ctx: any,_cache: any) => {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Locations", -1)),
      _createVNode(ListFilter, {
        dense: "",
        options: [],
        onFilter: updateFilter
      }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        "onClick:row": editLocation,
        headers: headers,
        items: filteredItems.value,
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.creationDate": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_unref(format)(value, 'do MMMM yyyy - HH:mm')), 1)
        ]),
        "item.translated": _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(TranslatedState, { item: item }, null, 8, ["item"])
          ])
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addLocation,
        color: "success"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Add Location")
        ])),
        _: 1
      }),
      _cache[2] || (_cache[2] = _createTextVNode("  "))
    ]),
    _: 1
  }))
}
}

})